let draftSequenceTracker: number = 1;

export class Context {
  jupyterProxyUrl: string | null = null;
  request: Request | null = null;
  normalizedPath: string | null = null;

  get draftSequence() {
    return draftSequenceTracker;
  }

  set draftSequence(value: number) {
    draftSequenceTracker = value;
  }
}

let currentContext = new Context();

export const setContext = (context: Context) => (currentContext = context);

export const getContext = () => currentContext;
